export enum UpdateContactType {
  TRIGGER = 'TRIGGER',
  PORTAL = 'PORTAL',
  BACKOFFICE = 'BACKOFFICE',
}
